// Imports
// ------
import React from 'react';
import styled from 'styled-components';
import { Div, H3, H4, P, Span } from '@reuse';
import { breakup } from '@break';
import { Row, Column } from 'react-foundation';
import ReactHtmlParser, { processNodes } from 'react-html-parser';
import { ExtLink }  from '@reuse';

// Images
// ------
const $sprite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAkCAYAAAG8t1mhAAAABGdBTUEAALGPC/xhBQAAA4JJREFUWAnVmG2ITGEUx/cNi/USQiKRJEk+KC9t3vKSlCgpRUoppXyQoiglSlGihOSDfOCDfJCS0kZIipIkikgiFLLLslh+Z/beO+eeeebeZ+7srNlTZ+455/8//3OenbvTnampKdX+YlEP8ZswiQFSpPAHv1MAFO0IAXtFocXWRP50TlrrE2/RubDEmuXFJVFYLGA5CohdFkXsswOOlyDty1F5iSHk7QHwJATIVwW1OBlCbUiSq5B0XovpPHPsrWI3SJyoz1SXyARUyvXCraOwWhVj/areyN+gMwIFEIsKBF2V3OsQXY/ikCCFMOY6JiK4AkWUcIqLU1ALmuYUAJUsMPR6MLit2+cgfD4Qjy7dNgTFI5FqEDjFwdbjH5xgkSL8HYGmvjQ46TBaNYv4hZMYFMFlIWsDk3oijK4O0/kgAgnAlhpc0hGa4x3T2GnEbptc0gnegklEh7CUZiT1ZMIQrQ2GLcokUKkmlmrCl1RKX26OxuDkcmmWQd4f7z5bIdoHXofhjjR59pQB9bK6sT3ZFU0nwuHNoWccMrTyUq0cxCfKUzTdjgHnDCWfQpbnsqn5SnrkGHCpaBfkX6phYlGiAhQ/DK8pOB7CmBuy1HVsnBXP4Mmptd2KMxwZ7MW6I4id9zeYPrVQ7zsk3SXIK6XD2FDNBvth8Mca94oRWGdEJG2SZq5tBnvuJeoiIbTZiEn6xdReu3pLqiG43Yjq9H1JYklkVPdq5SD+lNSTCUP4sBrUmknEp4khp/B2H26v53DQAfhNXOw7vqBXHYqF++FXcZd9pTirqg/Egg34Rdf2prazKg/CkvJV9KxZ1pXur8oDyFJse9y1sakdreYDHDTLutIzFEt72KVhAz690idnxm48zS5AyP384b0PDWvx30r5HfFkbwFPIprb1Ixi4RWAvp6SXTQaVuD2G68e8IpkfEmiDjIam3D7ZVfPkbgF7+9o9yvRPB//hifZM8DRfop5Fj32nXbNuEtxUL6rzAix5fhP1yRVe0Q8PG0UHHmn07QewhmWppUZR3wNrv9fSAvsHpXBdgi1hbg8RiTZU8BRtrdiOcM24mn39Q048iw0G5fHhiR7CTiuYgunCTN8a9J2HthbOJPS5vQYzjK7PJbWlI8k03pswVIHsdwBva0jlu98M0vV/W98lj1mDiEf4fP+20LlDGZx+XnrJL6sHJ1yev8BTgosntEtOAMAAAAASUVORK5CYII='

// Styles
// ------
const Jacket = styled(Div)``;

const QuestionJacket = styled(Div)``;

const Question = styled(Div)``;

const Answer = styled(Div)``;

const StyledP = styled(P)`
    &:last-child { margin-bottom: 0; }
`;

const Pre = styled(Span)`
    margin-bottom: 6rem;
    &:last-child { margin-bottom: 0; }
`;

const Button = styled(ExtLink)`
    color: ${props => props.theme.bc5};

    &:visited {
        color: ${props => props.theme.bc5};;
    }
`;

const List = styled.ul`
    list-style: none;
    display: block;
    position: relative;
    margin-bottom: 6rem;

    li {
        position: relative;
        display: block;
        padding-left: calc(4rem + 3.6rem);
        font-size: 1.6rem;
        line-height: 3rem;
        margin-bottom: 6rem;
        color: white;

        ${breakup.large`
            font-size: 2.2rem;
            line-height: 4rem;
            padding-left: calc(4rem + 6rem);
        `}

        &:last-child {
            margin-bottom: 0;
        }

        &:before {
            content: '';
            position: absolute;
            top: 0; left: 0;
            width: 4rem;
            height: 4rem;
            background-color: ${props => props.theme.bc5};
            background-image: url(${$sprite});
            background-repeat: no-repeat;
            background-size: 2.4rem 1.8rem;
            background-position: center center;
            border-radius: 2rem;
        }
    }
`;


// Component
// ------
function transform(node, index) {
    if (node.type === "tag" && node.name === "p") {
        return <StyledP space key={index}>{processNodes(node.children, transform)}</StyledP>;
    }

    if (node.type === "tag" && node.name === "a") {
        return <Button key={index} href={node.attribs.href}>{processNodes(node.children, transform)}</Button>;
    }

    if (node.type === "tag" & node.name === "h1" || node.name === "h2" || node.name === "h3" || node.name === "h4") {
        return <H4 key={index} space>{processNodes(node.children, transform)}</H4>;
    }

    if (node.type === "tag" && node.name === "ul") {
        return <List key={index} >{processNodes(node.children, transform)}</List>;
    }

    if (node.type === "tag" && node.name === "pre") {
        return <Pre key={index} >{processNodes(node.children, transform)}</Pre>;
    }
}

const options = {
    decodeEntities: true,
    transform
};

export default class MortgageQuestions extends React.Component {
    render() {
        return (
            <Jacket>
                {this.props.content.map(({question, answer}, index) => (
                    <QuestionJacket padBottom key={index}>
                        <Row isExpanded>
                            {/* Question */}
                            <Column small={12} large={3} pushOnLarge={2}>
                                <Question mpad space>
                                    <H3>{question}</H3>
                                </Question>
                            </Column>

                            {/* Answer */}
                            <Column small={12} large={5} pullOnLarge={1}>
                                <Answer mpad>{ReactHtmlParser(answer, options)}</Answer>
                            </Column>
                        </Row>
                    </QuestionJacket>
                ))}
            </Jacket>
        );
    }
}